import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import styles from "./dashboard.module.css";
// import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
// import { ReactComponent as Question } from "../../utils/assets/arrow.svg";
import { ReactComponent as Arrow } from "../../utils/assets/q.svg";
import RenderCheckBox from "components/dashboard/render-checkbox";
import Checkbox from "@material-ui/core/Checkbox";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Chart from "components/UI/Chart";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
// import Jsonpack from "jsonpack/main";
import { Typography } from "@material-ui/core";
import classNames from "classnames";
import { loadColorCode } from "../../utils/change-spo2-color";
import { getSpo2Value } from "../../utils/change-spo2-color";
import useSSE from "../../utils/hooks/useSSE";
import { addUsers } from "../../store/actions/userAction";
import { useDispatch } from "react-redux";  

export default function MainTable({
    group,
    members,
    fData,
    setFData,
    accessUser,
    count,
    loadData,
    user,
    setPageNumber,
    pageNumber,
    totalPages,
    totalRecords,
    pageSize,
    setPageSize
}) {
    // const axios = useAxiosPrivate();
    let navigate = useNavigate();
    let dateNow = new Date();

    const [filedOrder, setFiledOrder] = useState("asc");
    const [keys, setKeys] = useState([]);
    const [updatedUserData, setUpdatedUserData] = useState({});
    const dispatch = useDispatch();

    const handlePageChange = (event, value) => {
        setPageNumber(value);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPageNumber(1);
    };

    useEffect(() => {
        loadData("asc", "full_name");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, group, pageSize]);

    useEffect(() => {
        const interval = setInterval(() => {}, 5000);

        //  getData();

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const changeOrder = (filed) => {
        if (filedOrder === "asc") {
            loadData("desc", filed);
            setFiledOrder("desc");
        } else {
            loadData("asc", filed);
            setFiledOrder("asc");
        }
    };
    const direct = (item) => {
        navigate("/individualView", { state: item });
    };

    // const getSPO2Value = (fData, item) => {
    //     if (Object.keys(fData).length === 0) {
    //         return "--";
    //     }
    //     if (!item?.user_id) {
    //         return "--";
    //     }
    //     if (fData[String(item?.user_id)]) {
    //         const time = fData[String(item?.user_id)][
    //             fData[String(item?.user_id)]?.length - 1
    //         ]?.spo2;
    //         if (time === undefined) {
    //             return "--";
    //         } else {
    //             return `${time}`;
    //         }

    //     } else {
    //         return "--";
    //     }
    // }

    // const getSPO2Icon = (fData, item) => {
    //     if (Object.keys(fData).length === 0) {
    //         return "";
    //     }
    //     if (!item?.user_id) {
    //         return "";
    //     }
    //     if (fData[String(item?.user_id)]) {
    //         const time =
    //             fData[String(item?.user_id)][
    //                 fData[String(item?.user_id)]?.length - 1
    //             ]?.spo2;
    //         const signalQuality =
    //             fData[String(item?.user_id)][
    //                 fData[String(item?.user_id)]?.length - 1
    //             ]?.signal_quality;
    //         if (signalQuality === "Good") {
    //             if (time === undefined) {
    //                 return "";
    //             } else {
    //                 if (time <= 100 && time >= 95) {
    //                     return (
    //                         <Success
    //                             style={{ width: "0.9rem", height: "0.9rem" }}
    //                         />
    //                     );
    //                 }
    //                 if (time <= 94 && time >= 90) {
    //                     return (
    //                         <Warn
    //                             style={{ width: "0.9rem", height: "0.9rem" }}
    //                         />
    //                     );
    //                 }
    //                 if (time < 90) {
    //                     return (
    //                         <Error
    //                             style={{ width: "0.9rem", height: "0.9rem" }}
    //                         />
    //                     );
    //                 } else {
    //                     return "";
    //                 }
    //             }
    //         } else {
    //             if (time === undefined) {
    //                 return "";
    //             } else {
    //                 if (time <= 100 && time >= 95) {
    //                     return (
    //                         <SuccessGray
    //                             style={{ width: "0.9rem", height: "0.9rem" }}
    //                         />
    //                     );
    //                 }
    //                 if (time <= 94 && time >= 90) {
    //                     return (
    //                         <WarnGray
    //                             style={{ width: "0.9rem", height: "0.9rem" }}
    //                         />
    //                     );
    //                 }
    //                 if (time < 90) {
    //                     return (
    //                         <ErrorGray
    //                             style={{ width: "0.9rem", height: "0.9rem" }}
    //                         />
    //                     );
    //                 } else {
    //                     return "";
    //                 }
    //             }
    //         }
    //     } else {
    //         return "";
    //     }
    // };

    const getLastActiveTime = (fData, item, showActiveNow = false) => {
        if (Object.keys(fData).length === 0) {
            return "--";
        }
        if (!item?.user_id) {
            return "--";
        }
        if (fData[String(item?.user_id)]) {
            const time =
                fData[String(item?.user_id)][
                    fData[String(item?.user_id)]?.length - 1
                ]?.reading_time;
            if (time === undefined) {
                return "--";
            } else {
                // Check if the device is actively receiving data (within last 60 seconds)
                if (showActiveNow) {
                    const readingTime = new Date(time);
                    const now = new Date();
                    const diffInSeconds = (now - readingTime) / 1000;

                    if (diffInSeconds <= 60) {
                        return "Active now";
                    }
                }
                // Format UTC time to local machine time using date-fns
                return format(new Date(time), "yyyy-MM-dd HH:mm:ss");
            }
        } else {
            return "--";
        }
    };

    const handleSSEData = React.useCallback(
        (parsedData) => {
            if (parsedData && parsedData.data) {
                const incoming = parsedData.data || {};

                // Always keep fData equal to the raw SSE payload
                setFData(incoming);

                // Maintain updatedUserData as "latest non-empty values"
                setUpdatedUserData((prev) => {
                    // Initial call: make updatedUserData equal to fData/incoming
                    if (!prev || Object.keys(prev).length === 0) {
                        return incoming;
                    }

                    const merged = { ...prev };

                    Object.entries(incoming).forEach(([userId, readings]) => {
                        if (Array.isArray(readings) && readings.length > 0) {
                            // Non-empty array: update latest values for this user
                            merged[userId] = readings;
                        } else if (!(userId in merged)) {
                            // Brand new user with empty array: keep it as-is
                            merged[userId] = readings;
                        }
                        // If readings is an empty array and we already have data for this user,
                        // do NOT overwrite – we keep the previous non-empty values.
                    });

                    return merged;
                });
            }
        },
        [setFData],
    );

    // Handle SSE errors
    const handleSSEError = React.useCallback((error) => {
        console.error("SSE Error:", error);
    }, []);

    // Build SSE URL so hook reconnects when members change
    const memberIds = (members || [])
        .map((m) => m?.user_id || m?.member_id || m?.id)
        .filter(Boolean)
        .join(",");
    const sseUrl = `group/data?members=${encodeURIComponent(memberIds)}`;

    const handleToggleAll = (event) => {
        const { checked } = event.target;
        const existing = accessUser?.data || [];
    
        if (checked) {
          // Add all users from the current page to the global selection
          const existingIds = new Set(existing.map((u) => u.member_id));
          const merged = [
            ...existing,
            ...members.filter((m) => !existingIds.has(m.member_id)),
          ];
          dispatch(addUsers(merged));
        } else {
          // Remove only current page users from the global selection
          const pageIds = new Set(members.map((m) => m.member_id));
          const filtered = existing.filter((u) => !pageIds.has(u.member_id));
          dispatch(addUsers(filtered));
        }
      };

    const allChecked =
        members.length > 0 &&
        members.every((member) =>
        accessUser?.data?.some((u) => u.member_id === member.member_id)
    );

    useSSE(sseUrl, handleSSEData, handleSSEError);

    return (
        <div>
            <div className={styles.tableHead}>
                <div className={styles.header}>
                    <div className={styles.tittle6}>
                        <div
                            style={{
                                width: "30%",
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                                paddingLeft: "20px",
                            }}
                        >
                            <Checkbox
                                checked={allChecked}
                                onChange={handleToggleAll}
                                style={{
                                    transform: "scale(0.7)",
                                    color: "#23AFC4",
                                }}
                            />
                            <Typography
                                variant="h5"
                                style={{ fontSize: "14px", fontWeight: 400, whiteSpace: "nowrap" }}
                            >
                                {accessUser?.data?.length > 0
                                    ? `${accessUser.data.length}/${totalRecords}`
                                    : totalRecords}
                            </Typography>
                        </div>
                        <div style={{ width: "20%" }} />
                        <div
                            style={{
                                width: "50%",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                            }}
                            onClick={() => changeOrder("full_name")}
                        >
                            <Typography
                                variant="h5"
                                style={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
                            >
                                Username
                            </Typography>
                            <Arrow style={{ width: "0.8rem", height: "0.8rem" }} />
                        </div>
                    </div>
                    <div className={styles.tittle2}>
                        <Typography
                            variant="h5"
                            style={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
                        >
                            SpO₂ (%)
                        </Typography>
                        {/* <Question
                            style={{ width: "0.8rem", height: "0.8rem" }}
                        /> */}
                    </div>
                    <div className={styles.tittle3}>
                        <Typography
                            variant="h5"
                            style={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
                        >
                            Vitals
                        </Typography>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div
                                style={{
                                    borderBottom: "3px solid #A6CEE3",
                                    width: "1.5rem",
                                    marginRight: "5px",
                                }}
                            ></div>
                            <Typography
                                variant="h4"
                                style={{ fontSize: "12px", fontWeight: 400, marginRight: "5px" }}
                            >
                                SpO₂ (%)
                            </Typography>
                            <div
                                style={{
                                    borderBottom: "3px dashed #1F78B4",
                                    width: "1.5rem",
                                    margin: "0px 5px 0px 20px",
                                }}
                            ></div>
                            <Typography
                                variant="h4"
                                style={{ fontSize: "12px", fontWeight: 400, marginRight: "5px" }}
                            >
                                Pulse Rate (bpm)
                            </Typography>
                        </div>
                    </div>
                    <div className={styles.tittle4}>
                        <Typography
                            variant="h5"
                            style={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
                        >
                            Last Active Time
                        </Typography>
                        <Arrow style={{ width: "0.8rem", height: "0.8rem" }} />
                    </div>
                </div>
            </div>
            <div style={{ backgroundColor: "#FFFFFF", paddingBottom: "20px", borderRadius: "6px" }}>
            {members.map((item, index) => (
                <div className={styles.container} key={item.member_id}>
                    <div
                        className={
                            accessUser?.data?.find(
                                (m) => m.member_id === item.member_id,
                            )
                                ? styles.tBodyMark
                                : styles.tBody
                        }
                    >
                        <div
                            className={styles.tittle6}
                            style={{ cursor: "pointer" }}
                        >
                            <div className={styles.item1}>
                                <RenderCheckBox
                                    item={item}
                                    setKeys={setKeys}
                                    keys={keys}
                                />
                            </div>
                            <div
                                className={styles.item2}
                                onClick={() => {
                                    direct(item);
                                }}
                            >
                                {" "}
                                <Avatar
                                    alt={item?.first_name}
                                    src={item.avatar_url}
                                    sx={{ width: 28, height: 28, marginRight: "16px" }}
                                />
                            </div>
                            <div
                                className={styles.item3}
                                onClick={() => {
                                    direct(item);
                                }}
                            >
                                {" "}
                                <p
                                    className={
                                        accessUser?.data?.find(
                                            (m) =>
                                                m.member_id === item.member_id,
                                        )
                                            ? styles.tdTextMark
                                            : styles.tdText
                                    }
                                >
                                    {item?.first_name}&nbsp; {item?.last_name}
                                </p>
                            </div>
                        </div>
                        <div className={styles.tittle7}>
                            {/* Use updatedUserData so empty SSE arrays keep the last value. */}
                            {(() => {
                                const spo2Data = getSpo2Value(
                                    updatedUserData,
                                    item,
                                );
                                const isPlaceholder = spo2Data.value === '--';
                                return (
                                    <p
                                        className={
                                            isPlaceholder
                                                ? styles.tdNumber
                                                : styles.spo2Number
                                        }
                                        style={loadColorCode(
                                            updatedUserData,
                                            item,
                                        )}
                                    >
                                        {spo2Data.value}
                                    </p>
                                );
                            })()}
                            {/* <div>{getSPO2Icon(updatedUserData, item)}</div> */}
                        </div>
                        <div className={styles.tittles}>
                            <Chart
                                key={`chart-${item?.user_id}-${index}`}
                                fData={fData[String(item?.user_id)] || []}
                                height={60}
                            />

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <p className={styles.chartText}>
                                    {updatedUserData[item?.user_id]?.length > 0
                                        ? moment(
                                              getLastActiveTime(
                                                  updatedUserData,
                                                  item,
                                              ),
                                          )
                                              .subtract(2, "minutes")
                                              .format("hh:mm:ss A")
                                        : moment(dateNow)
                                              .subtract(2, "minutes")
                                              .format("hh:mm:ss A")}
                                </p>
                                <p className={styles.chartText}>
                                    {updatedUserData[item?.user_id]?.length > 0
                                        ? moment(
                                              getLastActiveTime(
                                                  updatedUserData,
                                                  item,
                                              ),
                                          )
                                              .subtract(1, "minutes")
                                              .format("hh:mm:ss A")
                                        : moment(dateNow)
                                              .subtract(1, "minutes")
                                              .format("hh:mm:ss A")}
                                </p>
                                <p className={styles.chartText}>
                                    {updatedUserData[item?.user_id]?.length > 0
                                        ? moment(
                                              getLastActiveTime(
                                                  updatedUserData,
                                                  item,
                                              ),
                                          ).format("hh:mm:ss A")
                                        : moment(dateNow).format("hh:mm:ss A")}
                                </p>
                            </div>
                        </div>

                        <div className={styles.tittle4}>
                            <p className={classNames(styles.tdNumber)}>
                                {getLastActiveTime(updatedUserData, item,true)}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
            </div>

            <div className={styles.Pagination}>
                <Stack spacing={2}>
                    <Pagination
                        count={totalPages}
                        page={pageNumber}
                        onChange={handlePageChange}
                        shape="rounded"
                        sx={{
                            "& .MuiPaginationItem-root": {
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "#ADADAD",
                                backgroundColor: "#FFFFFF",
                                border: "0.6px solid #23AFC4",
                                borderRadius: "2px",
                                minWidth: "22px",
                                height: "22px",
                            },
                            "& .MuiPaginationItem-root.Mui-selected": {
                                color: "#23AFC4",
                                backgroundColor: "#ECF9F7",
                            },
                        }}
                    />
                </Stack>
                <FormControl size="small">
                    <Select
                        value={pageSize}
                        onChange={handlePageSizeChange}
                        renderValue={(value) => `View ${value} items`}
                        sx={{
                            height: "22px",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "#ADADAD",
                            backgroundColor: "#FFFFFF",
                            ".MuiOutlinedInput-notchedOutline": {
                                borderColor: "#D4DEDF",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#D4DEDF",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#D4DEDF",
                            },
                            ".MuiSvgIcon-root": {
                                color: "#ADADAD",
                            },
                        }}
                    >
                        {[10, 20, 50].map((size) => (
                            <MenuItem key={size} value={size}>
                                {size}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </div>
    );
}
